var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115 1051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.077 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.92,66.818c.879-6.985-1.882-14.19-.246-21.036,1.264-5.286,5.025-9.7,6.245-15,1.809-7.851-2.331-15.911-7.614-21.954C45.672,4.679,41.112.9,35.676.142a18.347,18.347,0,0,0-9.908,1.644,25.146,25.146,0,0,0-8.3,6.074,25.437,25.437,0,0,0-5.21,8.916c-.7,2.146-1.13,4.391-2.009,6.472-1.515,3.586-4.3,6.479-6.03,9.965A19.08,19.08,0,0,0,3.586,48.5c2,5.05,6.2,9.273,6.828,14.676.452,3.894-.995,8.165.879,11.591,1.418,2.59,4.338,3.905,7.1,4.874,6.431,2.276,15.414,5.939,21.866,2.451A20.663,20.663,0,0,0,50.92,66.818Z",
    transform: "translate(-2.285 0)",
    fill: "#0d71e8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.587,76.867s-9.468-3.854-10.663-6.023S21.059,55.9,21.059,55.9",
    transform: "translate(-3.992 -5.081)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.031,135.633V52.447",
    transform: "translate(-5.353 -4.768)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.631 22.596)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.123,74.035c-.65-5.148,1.387-10.446.176-15.485-.931-3.893-3.691-7.143-4.6-11.042-1.332-5.779,1.715-11.715,5.6-16.153,2.675-3.058,6.032-5.834,10.034-6.39a13.415,13.415,0,0,1,7.293,1.211,18.51,18.51,0,0,1,6.112,4.471,18.734,18.734,0,0,1,3.836,6.564c.527,1.58.831,3.232,1.479,4.764,1.116,2.639,3.165,4.769,4.438,7.336a14.046,14.046,0,0,1,.463,11.255c-1.475,3.717-4.57,6.827-5.027,10.8-.318,2.854.736,6-.645,8.522-1.045,1.906-3.194,2.868-5.229,3.589-4.735,1.676-11.347,4.372-16.1,1.8A15.228,15.228,0,0,1,89.123,74.035Z",
    transform: "translate(-84.383 -24.856)",
    fill: "#0d71e8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.123,74.035c-.65-5.148,1.387-10.446.176-15.485-.931-3.893-3.691-7.143-4.6-11.042-1.332-5.779,1.715-11.715,5.6-16.153,2.675-3.058,6.032-5.834,10.034-6.39a13.415,13.415,0,0,1,7.293,1.211,18.51,18.51,0,0,1,6.112,4.471,18.734,18.734,0,0,1,3.836,6.564c.527,1.58.831,3.232,1.479,4.764,1.116,2.639,3.165,4.769,4.438,7.336a14.046,14.046,0,0,1,.463,11.255c-1.475,3.717-4.57,6.827-5.027,10.8-.318,2.854.736,6-.645,8.522-1.045,1.906-3.194,2.868-5.229,3.589-4.735,1.676-11.347,4.372-16.1,1.8A15.228,15.228,0,0,1,89.123,74.035Z",
    transform: "translate(-84.383 -24.856)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.207,81.435s6.971-2.84,7.849-4.438,2.109-11.005,2.109-11.005",
    transform: "translate(-86.185 -28.596)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.141,124.7V63.457",
    transform: "translate(-86.179 -28.365)",
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.868 86.091)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.109,101.418a1.72,1.72,0,0,0-.408-1.12,5.142,5.142,0,0,1-.367-.4,1.688,1.688,0,0,1-.251-.865,8.91,8.91,0,0,0-.16-2.206,2.16,2.16,0,0,0-1.454-1.2,1.343,1.343,0,0,0-.675-.11,1.081,1.081,0,0,0-.757.8,9.548,9.548,0,0,0-.175,1.152,1.317,1.317,0,0,1-.584.962,1.882,1.882,0,0,1-1.118.067,6.985,6.985,0,0,0-1.488-.014,2.29,2.29,0,0,0-.375.067A5.105,5.105,0,0,0,145.15,94.7c-3.415,0-4.992,1.889-5.6,3.791H139.5a6.991,6.991,0,0,0-1.488.014,1.878,1.878,0,0,1-1.118-.067,1.347,1.347,0,0,1-.584-.962c-.072-.383-.07-.779-.175-1.152a1.069,1.069,0,0,0-.757-.8,1.344,1.344,0,0,0-.675.11,2.161,2.161,0,0,0-1.454,1.2,8.834,8.834,0,0,0-.159,2.206,1.69,1.69,0,0,1-.252.865,5.146,5.146,0,0,1-.367.4,1.725,1.725,0,0,0-.408,1.12,1.678,1.678,0,0,0,.2.831c.364.647,1.1.98,1.6,1.523a1.212,1.212,0,0,1,.352.68,2.656,2.656,0,0,1-.2.887,1.917,1.917,0,0,0,.113,1.276,1.431,1.431,0,0,0,.158.263.935.935,0,0,0,.309.275c.439.227.968,0,1.461.028a1.629,1.629,0,0,1,.675.215H132.8a.816.816,0,0,0-.58.243.834.834,0,0,0-.24.586v2.945a.834.834,0,0,0,.24.586.816.816,0,0,0,.58.243h.655l.446,11.429.175,4.615.3,7.737a1.5,1.5,0,0,0,.453,1.018,1.474,1.474,0,0,0,1.025.418h15.565a1.474,1.474,0,0,0,1.025-.418,1.5,1.5,0,0,0,.453-1.018l.292-7.445.258-6.662.378-9.677h.655a.818.818,0,0,0,.581-.243.834.834,0,0,0,.24-.586v-2.946a.834.834,0,0,0-.24-.586.818.818,0,0,0-.581-.243h-1.065a1.624,1.624,0,0,1,.675-.215c.492-.035,1.021.2,1.461-.028a.944.944,0,0,0,.309-.275,1.481,1.481,0,0,0,.158-.263,1.922,1.922,0,0,0,.113-1.276,2.61,2.61,0,0,1-.2-.887,1.212,1.212,0,0,1,.352-.68c.506-.541,1.239-.874,1.6-1.523a1.677,1.677,0,0,0,.2-.831Zm-9.33,2.789a1.416,1.416,0,0,0,.1.136c.188.245.413.46.584.71a3.781,3.781,0,0,1,.5,1.846c.011.163.018.326.023.491h-6.821a24.283,24.283,0,0,0,.926-3.14c.622,1.4,2.545.9,2.545.9A5.373,5.373,0,0,0,148.779,104.207ZM141.3,98.582a3.7,3.7,0,0,1,4.734-2.391c2.19.628,2.722,1.346,2.663,3.884s-2.161,3.975-2.958,3.884a1.668,1.668,0,0,1-1.183-.9l-.148-.209c.415-1.644.74-3.078.74-3.078.445-2.181-1.183-1.793-1.183-1.793-1.983.355-1.183,3.287-1.183,3.287s-.858,4.154-.888,5.08c-.008.19-.042.589-.084,1.047h-1.625c0-.163.008-.327.023-.492a3.725,3.725,0,0,1,.5-1.845c.175-.257.4-.473.583-.71a.889.889,0,0,0,.176-.315.8.8,0,0,0-.051-.468l.033-.011h-.035v-.011a1.817,1.817,0,0,0-.1-.2l.276-1.479c-.443-.532-1.072-1.065-.3-3.28Z",
    transform: "translate(-131.977 -94.7)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.109,96.5a1.29,1.29,0,0,1,.65-.1,1.039,1.039,0,0,1,.729.774c.107.359.105.742.176,1.109a1.288,1.288,0,0,0,.562.927,1.8,1.8,0,0,0,1.077.064,6.745,6.745,0,0,1,1.436-.012c.4.039.879.178.99.565a1.472,1.472,0,0,1-.224.948,2.227,2.227,0,0,0,.015,1.806c.278.566.826.973,1.055,1.56a.776.776,0,0,1,.056.471.866.866,0,0,1-.165.3c-.176.235-.4.444-.563.69a3.507,3.507,0,0,0-.478,1.775,13.132,13.132,0,0,0,.011,1.834,12.208,12.208,0,0,0-1.406-.112c-.985-.2-1.6-1.383-2.6-1.454-.475-.034-.986.192-1.406-.029a1.066,1.066,0,0,1-.45-.518,1.849,1.849,0,0,1-.109-1.23,2.52,2.52,0,0,0,.19-.857,1.167,1.167,0,0,0-.352-.656c-.488-.524-1.195-.844-1.546-1.468a1.687,1.687,0,0,1,.2-1.884,4.735,4.735,0,0,0,.352-.388,1.63,1.63,0,0,0,.243-.835,8.54,8.54,0,0,1,.155-2.13A2.134,2.134,0,0,1,135.109,96.5Z",
    transform: "translate(-12.161 -8.763)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.379,96.537s2,11.2,4.591,12.537",
    transform: "translate(-12.418 -8.776)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.061,99.948a8.136,8.136,0,0,0-4.276,2.515",
    transform: "translate(-12.546 -9.086)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.777,104a5.506,5.506,0,0,0-4.218-1.349",
    transform: "translate(-12.162 -9.329)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.108,104.921s-3,.257-4.116,1.42",
    transform: "translate(-12.656 -9.538)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.168,107.676a4.928,4.928,0,0,0-3.234.71",
    transform: "translate(-12.378 -9.785)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.749,96.5a1.291,1.291,0,0,0-.65-.1,1.038,1.038,0,0,0-.73.774,11.016,11.016,0,0,0-.175,1.109,1.286,1.286,0,0,1-.563.927,1.8,1.8,0,0,1-1.077.064,6.736,6.736,0,0,0-1.435-.012c-.4.039-.879.178-.99.565a1.467,1.467,0,0,0,.224.948,2.222,2.222,0,0,1-.016,1.806c-.277.566-.825.973-1.055,1.56a.783.783,0,0,0-.056.471.884.884,0,0,0,.165.3c.175.235.4.444.563.69a3.525,3.525,0,0,1,.478,1.775,13.134,13.134,0,0,1-.011,1.834,12.191,12.191,0,0,1,1.406-.112c.984-.2,1.6-1.383,2.6-1.454.475-.034.986.192,1.406-.029a1.075,1.075,0,0,0,.45-.518,1.854,1.854,0,0,0,.109-1.23,2.5,2.5,0,0,1-.19-.857,1.16,1.16,0,0,1,.351-.656c.489-.524,1.2-.844,1.547-1.468a1.685,1.685,0,0,0-.2-1.884,4.892,4.892,0,0,1-.351-.388,1.621,1.621,0,0,1-.243-.835,8.538,8.538,0,0,0-.155-2.13A2.137,2.137,0,0,0,156.749,96.5Z",
    transform: "translate(-13.766 -8.763)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.931,96.537s-2,11.2-4.591,12.537",
    transform: "translate(-13.96 -8.776)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.277,99.948a8.136,8.136,0,0,1,4.276,2.515",
    transform: "translate(-13.863 -9.086)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.566,104a5.506,5.506,0,0,1,4.218-1.349",
    transform: "translate(-14.253 -9.329)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.242,104.921s3,.257,4.116,1.42",
    transform: "translate(-13.769 -9.538)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.285,107.868c-3.059,0-5.539-.633-5.539-1.281v1.494c0,.647,2.481,1.281,5.539,1.281s5.536-.634,5.538-1.281v-1.494C150.823,107.235,148.343,107.868,145.285,107.868Z",
    transform: "translate(-12.815 -9.69)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.582,105.285c-3.059,0-5.539-.633-5.539-1.281V105.5c0,.647,2.481,1.281,5.539,1.281s5.536-.634,5.538-1.281V104C150.12,104.652,147.64,105.285,144.582,105.285Z",
    transform: "translate(-12.751 -9.455)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.988,102.7c-3.059,0-5.539-.633-5.539-1.281v1.494c0,.648,2.481,1.281,5.539,1.281s5.536-.633,5.538-1.281v-1.494C151.526,102.069,149.047,102.7,145.988,102.7Z",
    transform: "translate(-12.879 -9.22)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.12,98.524c0,.648-2.48,1.253-5.538,1.253s-5.539-.6-5.539-1.253,2.48-1.1,5.539-1.1S150.12,97.876,150.12,98.524Z",
    transform: "translate(-12.751 -8.857)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.582,99.884c-3.059,0-5.539-.632-5.539-1.281V100.1c0,.648,2.481,1.282,5.539,1.282s5.536-.634,5.538-1.282V98.6C150.12,99.252,147.64,99.884,144.582,99.884Z",
    transform: "translate(-12.751 -8.964)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.98,99.325v1.493q.2.072.426.138V99.463Q140.175,99.4,139.98,99.325Z",
    transform: "translate(-12.836 -9.03)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.824,99.463v1.493c.155-.044.3-.09.426-.138V99.325C150.12,99.373,149.979,99.419,149.824,99.463Z",
    transform: "translate(-13.731 -9.03)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.152,99.647v1.494c.136.028.279.055.426.081V99.727C141.431,99.7,141.288,99.675,141.152,99.647Z",
    transform: "translate(-12.943 -9.059)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.648,99.728v1.494c.148-.025.29-.053.426-.081V99.647C148.938,99.675,148.8,99.7,148.648,99.728Z",
    transform: "translate(-13.624 -9.059)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,99.84v1.494c.139.017.281.035.426.049V99.89C142.6,99.875,142.459,99.858,142.32,99.84Z",
    transform: "translate(-13.049 -9.076)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,99.89v1.494c.146-.015.287-.032.426-.049V99.84C147.767,99.858,147.626,99.875,147.48,99.89Z",
    transform: "translate(-13.518 -9.076)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,99.955v1.494c.14.01.282.018.426.025V99.981C143.778,99.974,143.636,99.965,143.5,99.955Z",
    transform: "translate(-13.156 -9.087)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,99.981v1.494c.144-.007.285-.015.425-.025V99.955Q146.52,99.97,146.3,99.981Z",
    transform: "translate(-13.411 -9.087)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.112,100.012H144.9V101.5l.214,0,.213,0v-1.494Z",
    transform: "translate(-13.283 -9.092)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.387,102.143v1.493c.129.048.271.094.425.138V102.28C141.658,102.237,141.516,102.19,141.387,102.143Z",
    transform: "translate(-12.964 -9.286)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.227,102.28v1.494c.155-.045.3-.09.425-.138v-1.493C151.523,102.19,151.382,102.237,151.227,102.28Z",
    transform: "translate(-13.859 -9.286)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.559,102.465v1.494c.136.028.278.055.425.08v-1.494C142.837,102.52,142.7,102.493,142.559,102.465Z",
    transform: "translate(-13.071 -9.315)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.055,102.545v1.495c.147-.026.289-.053.425-.081v-1.494C150.344,102.493,150.2,102.52,150.055,102.545Z",
    transform: "translate(-13.752 -9.315)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.73,102.658v1.495c.139.017.281.035.426.049v-1.494C144.011,102.693,143.869,102.676,143.73,102.658Z",
    transform: "translate(-13.177 -9.333)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.883,102.708V104.2q.218-.023.425-.049v-1.495C149.17,102.676,149.028,102.693,148.883,102.708Z",
    transform: "translate(-13.646 -9.333)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,102.773v1.495c.14.009.282.018.426.025V102.8C145.18,102.791,145.038,102.783,144.9,102.773Z",
    transform: "translate(-13.283 -9.343)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.715,102.8v1.495c.144-.007.286-.016.426-.025v-1.495C148,102.783,147.859,102.791,147.715,102.8Z",
    transform: "translate(-13.54 -9.343)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.518,102.83l-.213,0v1.495h.425v-1.495Z",
    transform: "translate(-13.411 -9.348)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.98,104.726v1.493c.13.048.272.094.426.138v-1.494C140.252,104.82,140.11,104.773,139.98,104.726Z",
    transform: "translate(-12.836 -9.521)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.824,104.863v1.494c.155-.044.3-.09.426-.138v-1.493C150.12,104.773,149.979,104.82,149.824,104.863Z",
    transform: "translate(-13.731 -9.521)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.152,105.048v1.494c.136.028.279.055.426.08v-1.494C141.431,105.1,141.288,105.076,141.152,105.048Z",
    transform: "translate(-12.943 -9.55)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.648,105.128v1.495c.148-.026.29-.053.426-.081v-1.494C148.938,105.076,148.8,105.1,148.648,105.128Z",
    transform: "translate(-13.624 -9.55)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,105.241v1.495c.139.017.281.035.426.049v-1.494C142.6,105.276,142.459,105.259,142.32,105.241Z",
    transform: "translate(-13.049 -9.567)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,105.291v1.494c.146-.015.287-.032.426-.049v-1.495C147.767,105.259,147.626,105.276,147.48,105.291Z",
    transform: "translate(-13.518 -9.567)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,105.356v1.495c.14.009.282.018.426.025v-1.495C143.778,105.374,143.636,105.366,143.5,105.356Z",
    transform: "translate(-13.156 -9.578)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,105.381v1.495c.144-.007.285-.016.425-.025v-1.495C146.59,105.366,146.449,105.374,146.3,105.381Z",
    transform: "translate(-13.411 -9.578)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.112,105.413l-.214,0v1.495h.426v-1.495Z",
    transform: "translate(-13.283 -9.583)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.684,107.309V108.8c.129.048.271.094.425.138v-1.494C140.955,107.4,140.813,107.356,140.684,107.309Z",
    transform: "translate(-12.9 -9.755)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.523,107.446v1.494c.155-.045.3-.09.426-.138v-1.493C150.82,107.356,150.678,107.4,150.523,107.446Z",
    transform: "translate(-13.795 -9.755)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.855,107.63v1.494c.136.029.279.055.426.081v-1.494C142.134,107.685,141.991,107.659,141.855,107.63Z",
    transform: "translate(-13.007 -9.785)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.355,107.711V109.2c.148-.025.29-.052.426-.08V107.63C149.645,107.659,149.5,107.685,149.355,107.711Z",
    transform: "translate(-13.689 -9.785)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.027,107.824v1.495c.139.017.281.035.426.049v-1.494C143.308,107.859,143.166,107.842,143.027,107.824Z",
    transform: "translate(-13.113 -9.802)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.184,107.874v1.494c.145-.015.286-.032.425-.049v-1.495C148.47,107.842,148.329,107.859,148.184,107.874Z",
    transform: "translate(-13.582 -9.802)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,107.939v1.495c.14.009.282.018.426.025v-1.495C144.481,107.957,144.339,107.949,144.2,107.939Z",
    transform: "translate(-13.22 -9.813)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.012,107.964v1.495c.144-.007.285-.016.425-.025v-1.495C147.3,107.949,147.156,107.957,147.012,107.964Z",
    transform: "translate(-13.476 -9.813)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.815,108l-.213,0v1.495h.425v-1.495Z",
    transform: "translate(-13.347 -9.818)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.017,105.97c-.605.533-2.78.987-5.371.987a14.662,14.662,0,0,1-4.763-.654.35.35,0,0,0-.137.255c0,.649,2.48,1.254,5.539,1.254s5.538-.6,5.538-1.254C150.823,106.335,150.529,106.135,150.017,105.97Z",
    transform: "translate(-12.815 -9.634)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.86,104.36c-2.815,0-5.138-.536-5.491-1.127-.826.187-1.326.437-1.326.728,0,.648,2.48,1.254,5.539,1.254s5.538-.605,5.538-1.254a.266.266,0,0,0-.015-.084A16.64,16.64,0,0,1,145.86,104.36Z",
    transform: "translate(-12.751 -9.385)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.034,100.611c-.663.516-2.795.95-5.324.95a17.034,17.034,0,0,1-4.115-.448.36.36,0,0,0-.145.262c0,.649,2.48,1.254,5.539,1.254s5.538-.6,5.538-1.254C151.526,101.065,150.959,100.8,150.034,100.611Z",
    transform: "translate(-12.879 -9.146)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.277,107.676a4.931,4.931,0,0,1,3.235.71",
    transform: "translate(-14.136 -9.785)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8,110.958l-.469,11.995-.249,6.424-.282,7.178a1.449,1.449,0,0,1-.436.982,1.419,1.419,0,0,1-.989.4H136.366a1.419,1.419,0,0,1-.989-.4,1.449,1.449,0,0,1-.436-.982l-.292-7.455-.176-4.452-.527-13.684Z",
    transform: "translate(-12.288 -10.087)",
    fill: "#f0e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.194,109.006H133.279a.8.8,0,0,0-.791.8v2.84a.8.8,0,0,0,.791.8h20.915a.794.794,0,0,0,.791-.8v-2.84A.794.794,0,0,0,154.194,109.006Z",
    transform: "translate(-12.155 -9.91)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.386,124.1l-.249,6.424c-2.768-.79-7.031-1.587-9.915-.135-2.32,1.171-5.726.649-8.519-.148l-.176-4.451c2.035.749,4.31,1.075,5.881-.194C143.069,123.446,149.655,123.125,153.386,124.1Z",
    transform: "translate(-12.341 -11.234)",
    fill: "#0d71e8",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.215,140.315s3.294-4.575,6.679-4.157C94.894,136.159,91.28,140.037,88.215,140.315Z",
    transform: "translate(-8.083 -12.376)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.215,140.319s5.976-4.275,6.656-4.135",
    transform: "translate(-8.083 -12.38)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,141.575s-3.821-4.134-2.775-7.411C79.726,134.162,82.814,138.483,82.5,141.575Z",
    transform: "translate(-7.287 -12.197)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.515,141.578s-3.021-6.731-2.756-7.384",
    transform: "translate(-7.305 -12.199)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.977,139.161c-1.484,0-2.687-.307-2.687-.622v.725c0,.315,1.2.622,2.687.622s2.687-.307,2.687-.622v-.725C88.664,138.854,87.461,139.161,85.977,139.161Z",
    transform: "translate(-7.631 -12.594)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.637,137.907c-1.484,0-2.687-.306-2.687-.621v.725c0,.315,1.2.622,2.687.622s2.687-.307,2.688-.622v-.725C88.324,137.6,87.121,137.907,85.637,137.907Z",
    transform: "translate(-7.6 -12.481)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.316,136.654c-1.484,0-2.687-.306-2.687-.621v.725c0,.315,1.2.622,2.687.622S89,137.072,89,136.758v-.725C89,136.348,87.8,136.654,86.316,136.654Z",
    transform: "translate(-7.663 -12.367)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.324,134.627c0,.315-1.2.608-2.688.608s-2.687-.294-2.687-.608,1.2-.531,2.687-.531S88.324,134.312,88.324,134.627Z",
    transform: "translate(-7.6 -12.191)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.637,135.287c-1.484,0-2.687-.307-2.687-.622v.725c0,.315,1.2.622,2.687.622s2.687-.307,2.688-.622v-.725C88.324,134.98,87.121,135.287,85.637,135.287Z",
    transform: "translate(-7.6 -12.242)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.406,135.016v.725c.063.023.132.045.207.066v-.725C83.538,135.061,83.469,135.039,83.406,135.016Z",
    transform: "translate(-7.64 -12.274)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,135.082v.725c.075-.021.144-.044.207-.066v-.725C88.324,135.039,88.255,135.061,88.18,135.082Z",
    transform: "translate(-8.077 -12.274)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.973,135.172v.725c.066.014.135.026.207.039v-.725C84.108,135.2,84.039,135.186,83.973,135.172Z",
    transform: "translate(-7.692 -12.288)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.609,135.211v.725c.072-.013.141-.025.207-.039v-.725C87.75,135.186,87.681,135.2,87.609,135.211Z",
    transform: "translate(-8.025 -12.288)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.539,135.266v.725c.067.009.136.016.207.024v-.725Z",
    transform: "translate(-7.744 -12.297)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.043,135.29v.725c.071-.008.139-.015.207-.025v-.725Z",
    transform: "translate(-7.973 -12.297)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.109,135.321v.725l.207.013v-.725C85.246,135.33,85.177,135.326,85.109,135.321Z",
    transform: "translate(-7.796 -12.302)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.473,135.334v.725l.207-.013v-.725C86.612,135.326,86.543,135.33,86.473,135.334Z",
    transform: "translate(-7.921 -12.302)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.892,135.349h-.1v.725H86v-.725Z",
    transform: "translate(-7.858 -12.304)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.086,136.383v.725c.063.023.132.045.207.066v-.725C84.218,136.428,84.149,136.406,84.086,136.383Z",
    transform: "translate(-7.702 -12.398)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.863,136.449v.725c.075-.021.144-.044.207-.066v-.725C89.007,136.406,88.938,136.428,88.863,136.449Z",
    transform: "translate(-8.14 -12.398)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.656,136.539v.725c.066.014.135.027.207.039v-.725C84.791,136.566,84.722,136.553,84.656,136.539Z",
    transform: "translate(-7.755 -12.413)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.293,136.578v.725c.072-.012.141-.025.207-.039v-.725C88.434,136.553,88.365,136.566,88.293,136.578Z",
    transform: "translate(-8.088 -12.413)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.223,136.633v.725c.067.009.136.017.207.025v-.725Z",
    transform: "translate(-7.806 -12.421)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.727,136.657v.725c.071-.007.139-.015.207-.025v-.725C87.866,136.642,87.8,136.649,87.727,136.657Z",
    transform: "translate(-8.036 -12.421)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.789,136.689v.725l.207.013V136.7C85.926,136.7,85.857,136.694,85.789,136.689Z",
    transform: "translate(-7.858 -12.426)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.156,136.7v.725l.207-.013v-.725C87.3,136.694,87.226,136.7,87.156,136.7Z",
    transform: "translate(-7.984 -12.426)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.576,136.716h-.1v.725h.207v-.725Z",
    transform: "translate(-7.921 -12.429)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.406,137.636v.725c.063.024.132.045.207.067V137.7C83.538,137.681,83.469,137.66,83.406,137.636Z",
    transform: "translate(-7.64 -12.512)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,137.7v.725c.075-.022.144-.044.207-.067v-.725C88.324,137.66,88.255,137.681,88.18,137.7Z",
    transform: "translate(-8.077 -12.512)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.973,137.792v.725c.066.014.135.026.207.039v-.725C84.108,137.819,84.039,137.806,83.973,137.792Z",
    transform: "translate(-7.692 -12.527)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.609,137.831v.725c.072-.013.141-.025.207-.04v-.725C87.75,137.806,87.681,137.819,87.609,137.831Z",
    transform: "translate(-8.025 -12.527)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.539,137.886v.725l.207.024v-.725C84.675,137.9,84.606,137.9,84.539,137.886Z",
    transform: "translate(-7.744 -12.535)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.043,137.911v.725l.207-.024v-.725C87.182,137.9,87.114,137.9,87.043,137.911Z",
    transform: "translate(-7.973 -12.535)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.109,137.942v.725c.068.005.137.009.207.013v-.725Z",
    transform: "translate(-7.796 -12.54)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.473,137.955v.725c.07,0,.139-.007.207-.013v-.725Z",
    transform: "translate(-7.921 -12.54)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.892,137.969h-.1v.725H86v-.725Z",
    transform: "translate(-7.858 -12.543)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.746,138.889v.725c.063.024.132.045.207.067v-.725C83.878,138.934,83.809,138.913,83.746,138.889Z",
    transform: "translate(-7.671 -12.626)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,138.956v.725c.075-.021.144-.044.207-.067v-.725C88.663,138.913,88.595,138.934,88.52,138.956Z",
    transform: "translate(-8.108 -12.626)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.313,139.046v.725c.066.014.135.026.207.039v-.725C84.448,139.072,84.379,139.06,84.313,139.046Z",
    transform: "translate(-7.723 -12.641)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.953,139.085v.725c.072-.013.141-.025.207-.039v-.725C88.094,139.06,88.025,139.072,87.953,139.085Z",
    transform: "translate(-8.057 -12.641)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.883,139.14v.725c.067.009.136.016.207.024v-.725Z",
    transform: "translate(-7.775 -12.649)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.383,139.164v.725l.207-.024v-.725Z",
    transform: "translate(-8.004 -12.649)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.449,139.2v.725c.068,0,.137.009.207.012v-.725C85.586,139.2,85.517,139.2,85.449,139.2Z",
    transform: "translate(-7.827 -12.654)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.816,139.208v.725c.07,0,.139-.007.207-.012V139.2C86.955,139.2,86.886,139.2,86.816,139.208Z",
    transform: "translate(-7.952 -12.654)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.236,139.223h-.1v.725h.207v-.725Z",
    transform: "translate(-7.89 -12.657)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.272,138.24a5.2,5.2,0,0,1-2.606.479,7.1,7.1,0,0,1-2.311-.317.17.17,0,0,0-.067.124c0,.315,1.2.608,2.687.608s2.687-.294,2.687-.608C88.664,138.417,88.521,138.32,88.272,138.24Z",
    transform: "translate(-7.631 -12.567)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.257,137.459a4.406,4.406,0,0,1-2.664-.547c-.4.091-.644.212-.644.354,0,.315,1.2.608,2.687.608s2.688-.294,2.688-.608a.122.122,0,0,0-.008-.041A8.064,8.064,0,0,1,86.257,137.459Z",
    transform: "translate(-7.6 -12.447)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,135.639a5.4,5.4,0,0,1-2.583.462,8.243,8.243,0,0,1-2-.218.176.176,0,0,0-.071.127c0,.315,1.2.608,2.687.608S89,136.325,89,136.01C89,135.86,88.729,135.732,88.28,135.639Z",
    transform: "translate(-7.663 -12.331)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.113,141.406l-.545,8.829-.093,1.5a1.2,1.2,0,0,1-.37.795,1.174,1.174,0,0,1-.809.324H78.76a1.174,1.174,0,0,1-.809-.324,1.2,1.2,0,0,1-.37-.795l-.128-2.072-.511-8.259Z",
    transform: "translate(-7.053 -12.855)",
    fill: "#f0e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.045,143.207H91.009l.1-1.67H76.941Z",
    transform: "translate(-7.053 -12.867)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.746,139.963H77.213a.8.8,0,0,0-.791.8v1.385a.8.8,0,0,0,.791.8H90.746a.8.8,0,0,0,.791-.8v-1.385A.8.8,0,0,0,90.746,139.963Z",
    transform: "translate(-7.006 -12.724)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.617,150.941l-.093,1.5a1.2,1.2,0,0,1-.37.795,1.174,1.174,0,0,1-.809.324H78.812a1.174,1.174,0,0,1-.809-.324,1.2,1.2,0,0,1-.37-.795l-.128-2.072a5.483,5.483,0,0,1,5.392-.865A22.566,22.566,0,0,0,90.617,150.941Z",
    transform: "translate(-7.105 -13.561)",
    fill: "#0d71e8",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.685 93.344)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.567,125.185H115.1a9.092,9.092,0,0,0,1.459-3.415,4.014,4.014,0,0,1,0-.61,9.4,9.4,0,0,0,1.006-1.017l-1,.2c.5-.2.6-1.219.624-1.219l-1.007.611s-.3-.82-1.712-.82a2.1,2.1,0,0,0-1.492.624,2.14,2.14,0,0,0-.617,1.506,1.644,1.644,0,0,0,.04.447l-.2.04c-.175-.01-.352-.028-.51-.051l.086-.091a3.92,3.92,0,0,0-.669-.023,4.819,4.819,0,0,1-2.988-2.05c-.774.8.165,2.218.6,2.8l-.239.135a1.587,1.587,0,0,1-.565-.289,2.111,2.111,0,0,0,.034.628,14.841,14.841,0,0,0-2.782,2.583h-.218a30.71,30.71,0,0,0-.155-9.457,6.275,6.275,0,0,1,1.878-3.658,7.268,7.268,0,0,1,2.324-1.385l.1-.043a1.47,1.47,0,0,0,.8.755,1.447,1.447,0,0,0,1.1-.022,1.468,1.468,0,0,0,.773-.785,1.487,1.487,0,0,0,.014-1.106,1.468,1.468,0,0,0-.752-.805,1.452,1.452,0,0,0-1.1-.05,1.469,1.469,0,0,0-.821.734,1.489,1.489,0,0,0-.085,1.1l-.105.043a7.424,7.424,0,0,0-2.378,1.42,6.431,6.431,0,0,0-1.861,3.326,11.738,11.738,0,0,0-1.009-2.715,8.711,8.711,0,0,1-1.021-3.154,6.326,6.326,0,0,0,.889.06,7.585,7.585,0,0,0,3.425-.824,1.48,1.48,0,0,0,2.655-.562,1.511,1.511,0,0,0-.194-1.107,1.479,1.479,0,0,0-2.685.39,1.514,1.514,0,0,0,.124,1.118,7.229,7.229,0,0,1-4.233.731,6.211,6.211,0,0,1,.847-3.712,1.509,1.509,0,0,0,2.087-.337,1.542,1.542,0,0,0-.269-2.117,1.507,1.507,0,0,0-2.1.205,1.544,1.544,0,0,0,.138,2.13c-.812,1.347-1.6,3.794.1,7.118-.77-.067-4.042-.433-5.018-1.856-.014-.022-.026-.045-.04-.066a1.5,1.5,0,0,0,.916-.634,1.526,1.526,0,0,0-.344-2.055,1.491,1.491,0,0,0-2.051.234,1.527,1.527,0,0,0,.119,2.081,1.49,1.49,0,0,0,1.033.412h.125c.026.048.054.1.086.143,1.1,1.6,4.771,1.912,5.272,1.952a15.641,15.641,0,0,1,1.463,6.188c-.515.085-3.188.485-4.589-.156a1.54,1.54,0,0,0,.084-2.125,1.505,1.505,0,0,0-2.1-.157,1.541,1.541,0,0,0-.226,2.115,1.5,1.5,0,0,0,2.085.3,5.616,5.616,0,0,0,2.388.416,15.219,15.219,0,0,0,2.37-.2,36.191,36.191,0,0,1-.259,6.148h-.335a22.107,22.107,0,0,0-2.194-4.013,5.838,5.838,0,0,0,.435,4.013h-2.438a.842.842,0,0,0-.6.25.86.86,0,0,0-.248.6v3.035a.859.859,0,0,0,.256.589.84.84,0,0,0,.59.242h.058l.013.19h.012l.638,10.3.2,3.3a1.909,1.909,0,0,0,.592,1.262,1.868,1.868,0,0,0,1.285.513h16.759a1.868,1.868,0,0,0,1.285-.513,1.909,1.909,0,0,0,.592-1.262l.147-2.39.693-11.2h.012l.013-.19h.058a.841.841,0,0,0,.6-.25.855.855,0,0,0,.247-.6v-3.035a.849.849,0,0,0-.526-.787A.841.841,0,0,0,122.567,125.185Zm-13.624-1.308a2.3,2.3,0,0,0,.365.129.617.617,0,0,1-.8.2,1.806,1.806,0,0,0,.979.976h-2.672A13.858,13.858,0,0,0,108.943,123.877Z",
    transform: "translate(-96.543 -102.678)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,127.31l-.175-.035c.017-.086,1.721-8.761-.879-13.645-2.636-4.97.689-7.892.725-7.92l.113.135c-.034.028-3.252,2.854-.682,7.7C107.336,118.483,105.619,127.222,105.6,127.31Z",
    transform: "translate(-9.485 -9.61)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6,110.969a5.123,5.123,0,0,1-.986-.082l.039-.177a6.8,6.8,0,0,0,5.335-1.491l.11.138A7.126,7.126,0,0,1,104.6,110.969Z",
    transform: "translate(-9.493 -9.929)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.215,114.142c-.158-.009-3.9-.248-4.981-1.825a1.65,1.65,0,0,1-.193-1.485l.176.053a1.48,1.48,0,0,0,.176,1.332c1.03,1.5,4.809,1.746,4.847,1.748Z",
    transform: "translate(-9.066 -10.076)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.957,117.059l-.176-.017A6.075,6.075,0,0,1,107.6,113.5a6.949,6.949,0,0,1,2.224-1.325,2.853,2.853,0,0,0,1.282-.794l.136.112a3.088,3.088,0,0,1-1.353.847,6.767,6.767,0,0,0-2.173,1.294A5.9,5.9,0,0,0,105.957,117.059Z",
    transform: "translate(-9.692 -10.126)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.455,121.079a4.271,4.271,0,0,1-2.6-.625,1.245,1.245,0,0,1-.347-.446,1.262,1.262,0,0,1-.115-.556h.175a1.071,1.071,0,0,0,.4.866c1.215,1.021,4.745.384,4.775.378l.032.177A14.2,14.2,0,0,1,103.455,121.079Z",
    transform: "translate(-9.199 -10.859)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.809,127.623s3.294-4.574,6.678-4.157C112.487,123.467,108.874,127.346,105.809,127.623Z",
    transform: "translate(-9.696 -11.222)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.081,130.641s-3.821-4.135-2.775-7.411C103.311,123.228,106.4,127.549,106.081,130.641Z",
    transform: "translate(-9.448 -11.203)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.877,127.772c3.059,0,5.538-.632,5.538-1.28v1.493c0,.648-2.48,1.282-5.538,1.282s-5.537-.634-5.539-1.282v-1.493C107.338,127.14,109.818,127.772,112.877,127.772Z",
    transform: "translate(-9.838 -11.499)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,125.189c3.059,0,5.539-.632,5.539-1.28V125.4c0,.648-2.481,1.282-5.539,1.282s-5.537-.634-5.539-1.282v-1.493C108.041,124.557,110.521,125.189,113.58,125.189Z",
    transform: "translate(-9.903 -11.264)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.174,122.607c3.058,0,5.538-.633,5.538-1.281v1.493c0,.648-2.48,1.282-5.538,1.282s-5.537-.634-5.539-1.282v-1.493C106.635,121.974,109.115,122.607,112.174,122.607Z",
    transform: "translate(-9.774 -11.03)",
    fill: "#e4af18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.041,118.429c0,.648,2.48,1.254,5.539,1.254s5.539-.605,5.539-1.254-2.48-1.095-5.539-1.095S108.041,117.78,108.041,118.429Z",
    transform: "translate(-9.903 -10.667)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,119.789c3.059,0,5.539-.633,5.539-1.281V120c0,.647-2.481,1.281-5.539,1.281s-5.537-.634-5.539-1.281v-1.494C108.041,119.156,110.521,119.789,113.58,119.789Z",
    transform: "translate(-9.903 -10.773)",
    fill: "#f4bf1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.246,119.23v1.493c-.129.048-.271.094-.426.138v-1.494C118.975,119.324,119.117,119.277,119.246,119.23Z",
    transform: "translate(-10.884 -10.839)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,119.367v1.494c-.155-.045-.3-.09-.425-.138V119.23C109.106,119.277,109.248,119.324,109.4,119.367Z",
    transform: "translate(-9.982 -10.839)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.074,119.552v1.494c-.136.028-.278.055-.425.08v-1.494C117.8,119.607,117.938,119.58,118.074,119.552Z",
    transform: "translate(-10.777 -10.868)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.578,119.632v1.495c-.147-.026-.29-.053-.426-.081v-1.494C110.288,119.58,110.431,119.607,110.578,119.632Z",
    transform: "translate(-10.09 -10.868)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.906,119.745v1.494c-.139.018-.28.035-.425.05V119.8C116.626,119.78,116.767,119.763,116.906,119.745Z",
    transform: "translate(-10.67 -10.886)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.746,119.8v1.494c-.145-.015-.287-.032-.426-.049v-1.495C111.459,119.763,111.6,119.78,111.746,119.8Z",
    transform: "translate(-10.197 -10.886)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,119.86v1.495c-.14.009-.282.018-.425.025v-1.495C115.449,119.878,115.59,119.87,115.73,119.86Z",
    transform: "translate(-10.562 -10.896)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.922,119.885v1.495c-.145-.007-.286-.016-.426-.025V119.86C112.636,119.87,112.778,119.878,112.922,119.885Z",
    transform: "translate(-10.305 -10.896)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.116,119.917l.213,0v1.495H113.9v-1.495Z",
    transform: "translate(-10.434 -10.901)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,122.047v1.494c-.13.048-.272.094-.426.138v-1.494Q117.646,122.12,117.84,122.047Z",
    transform: "translate(-10.755 -11.095)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,122.185v1.494c-.155-.045-.3-.09-.426-.138v-1.494Q107.769,122.119,108,122.185Z",
    transform: "translate(-9.854 -11.095)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.668,122.369v1.494c-.136.029-.278.055-.426.081V122.45C116.39,122.424,116.532,122.4,116.668,122.369Z",
    transform: "translate(-10.648 -11.124)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.172,122.45v1.494c-.148-.025-.29-.052-.426-.081v-1.494C108.882,122.4,109.024,122.424,109.172,122.45Z",
    transform: "translate(-9.961 -11.124)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5,122.563v1.494c-.139.018-.281.035-.426.05v-1.494C115.215,122.6,115.357,122.581,115.5,122.563Z",
    transform: "translate(-10.541 -11.142)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,122.612v1.495c-.145-.015-.287-.032-.426-.05v-1.494C110.053,122.581,110.195,122.6,110.34,122.612Z",
    transform: "translate(-10.068 -11.142)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.328,122.678v1.494c-.14.01-.282.019-.426.026V122.7C114.047,122.7,114.188,122.688,114.328,122.678Z",
    transform: "translate(-10.434 -11.153)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.512,122.7V124.2c-.145-.007-.286-.016-.426-.026v-1.494C111.226,122.688,111.368,122.7,111.512,122.7Z",
    transform: "translate(-10.176 -11.153)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.71,122.735l.213,0v1.495H112.5v-1.495Z",
    transform: "translate(-10.305 -11.158)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.246,124.63v1.494c-.129.048-.271.094-.426.138v-1.494Q119.053,124.7,119.246,124.63Z",
    transform: "translate(-10.884 -11.33)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,124.768v1.494c-.155-.045-.3-.09-.425-.138V124.63Q109.171,124.7,109.4,124.768Z",
    transform: "translate(-9.982 -11.33)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.074,124.952v1.494c-.136.029-.278.055-.425.081v-1.494C117.8,125.007,117.938,124.981,118.074,124.952Z",
    transform: "translate(-10.777 -11.359)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.578,125.033v1.494c-.147-.025-.29-.052-.426-.081v-1.494C110.288,124.981,110.431,125.007,110.578,125.033Z",
    transform: "translate(-10.09 -11.359)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.906,125.146v1.494c-.139.018-.28.035-.425.05V125.2C116.626,125.181,116.767,125.164,116.906,125.146Z",
    transform: "translate(-10.67 -11.377)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.746,125.2v1.495c-.145-.015-.287-.032-.426-.05v-1.494C111.459,125.164,111.6,125.181,111.746,125.2Z",
    transform: "translate(-10.197 -11.377)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,125.261v1.494c-.14.01-.282.019-.425.026v-1.495C115.449,125.279,115.59,125.271,115.73,125.261Z",
    transform: "translate(-10.562 -11.387)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.922,125.286v1.495c-.145-.007-.286-.016-.426-.026v-1.494C112.636,125.271,112.778,125.279,112.922,125.286Z",
    transform: "translate(-10.305 -11.387)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.116,125.317h.213v1.495H113.9v-1.495Z",
    transform: "translate(-10.434 -11.392)",
    fill: "#dca815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.543,127.213v1.494q-.195.071-.426.138v-1.494C118.272,127.307,118.413,127.261,118.543,127.213Z",
    transform: "translate(-10.82 -11.565)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,127.351v1.494q-.232-.067-.426-.138v-1.494C108.407,127.261,108.549,127.307,108.7,127.351Z",
    transform: "translate(-9.918 -11.565)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.371,127.535v1.494c-.136.028-.278.055-.426.081v-1.494C117.093,127.59,117.235,127.564,117.371,127.535Z",
    transform: "translate(-10.712 -11.594)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.871,127.616v1.494c-.147-.025-.29-.052-.426-.081v-1.494C109.581,127.564,109.724,127.59,109.871,127.616Z",
    transform: "translate(-10.025 -11.594)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,127.729v1.494c-.139.018-.28.035-.425.05v-1.495C115.919,127.764,116.06,127.746,116.2,127.729Z",
    transform: "translate(-10.605 -11.612)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.043,127.778v1.495c-.145-.015-.287-.032-.426-.05v-1.494C110.756,127.747,110.9,127.764,111.043,127.778Z",
    transform: "translate(-10.133 -11.612)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.027,127.844v1.494c-.14.01-.282.019-.425.026v-1.495C114.746,127.862,114.887,127.854,115.027,127.844Z",
    transform: "translate(-10.498 -11.622)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.215,127.869v1.495c-.145-.007-.286-.016-.426-.026v-1.494C111.929,127.854,112.071,127.862,112.215,127.869Z",
    transform: "translate(-10.24 -11.622)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.413,127.9h.213v1.495H113.2V127.9Z",
    transform: "translate(-10.369 -11.627)",
    fill: "#c49214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.145,125.874c.6.534,2.78.988,5.371.988a14.641,14.641,0,0,0,4.763-.655.355.355,0,0,1,.136.255c0,.648-2.479,1.253-5.538,1.253s-5.539-.6-5.539-1.253C107.338,126.239,107.633,126.039,108.145,125.874Z",
    transform: "translate(-9.838 -11.443)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,124.265c2.815,0,5.137-.536,5.491-1.127.826.187,1.326.437,1.326.728,0,.648-2.48,1.253-5.539,1.253s-5.539-.6-5.539-1.253a.254.254,0,0,1,.016-.085A16.63,16.63,0,0,0,112.3,124.265Z",
    transform: "translate(-9.903 -11.194)",
    fill: "#ffd949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.128,120.515c.663.517,2.795.95,5.325.95a17.025,17.025,0,0,0,4.115-.448.36.36,0,0,1,.145.263c0,.649-2.48,1.254-5.538,1.254s-5.539-.6-5.539-1.254C106.635,120.97,107.2,120.706,108.128,120.515Z",
    transform: "translate(-9.774 -10.956)",
    fill: "#fcc62d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.263,129.507l-.812,13.135-.139,2.235a1.776,1.776,0,0,1-.552,1.185,1.746,1.746,0,0,1-1.205.481H103.876a1.746,1.746,0,0,1-1.205-.481,1.78,1.78,0,0,1-.552-1.185l-.19-3.083-.761-12.292Z",
    transform: "translate(-9.279 -11.773)",
    fill: "#f0e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.327,132.188H122.11l.153-2.485H101.172Z",
    transform: "translate(-9.279 -11.791)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,127.36H101.189a.8.8,0,0,0-.791.8V131a.8.8,0,0,0,.791.8H122.1a.794.794,0,0,0,.791-.8v-2.84A.794.794,0,0,0,122.1,127.36Z",
    transform: "translate(-9.209 -11.578)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.526,143.7l-.139,2.235a1.784,1.784,0,0,1-.552,1.185,1.746,1.746,0,0,1-1.205.481H103.951a1.744,1.744,0,0,1-1.205-.481,1.776,1.776,0,0,1-.552-1.185L102,142.85a8.158,8.158,0,0,1,8.027-1.287C115.207,143.219,118.387,143.778,121.526,143.7Z",
    transform: "translate(-9.354 -12.824)",
    fill: "#0d71e8",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.378,107.062a1.42,1.42,0,1,0-1.405-1.42A1.413,1.413,0,0,0,105.378,107.062Z",
    transform: "translate(-9.525 -9.475)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.343,110.675a1.42,1.42,0,1,0-1.405-1.42A1.414,1.414,0,0,0,109.343,110.675Z",
    transform: "translate(-9.888 -9.803)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.664,113.018a1.42,1.42,0,1,0-1.406-1.42A1.413,1.413,0,0,0,111.664,113.018Z",
    transform: "translate(-10.101 -10.016)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,112.041a1.42,1.42,0,1,0-1.406-1.42A1.413,1.413,0,0,0,98.9,112.041Z",
    transform: "translate(-8.932 -9.927)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.253,120.828a1.42,1.42,0,1,0-1.406-1.42A1.413,1.413,0,0,0,100.253,120.828Z",
    transform: "translate(-9.056 -10.726)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.036)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,57.445a12.248,12.248,0,0,0,1.933,6.31s6.746,8.8,7.733,12.633l8.674,12.166c-.381,1.228-4.173,13.618-4.115,20.2a13.178,13.178,0,0,0,.07,1.42s.016.343.018.924c0,2.438-.29,8.477-2.83,11.715h.023l.016.011h.025l-.074.1.077.046c-.617,1.873,1.055,4,1.055,4l2.529,6.39h1.687l1.617-.994,1.265,1.7a93.146,93.146,0,0,0,9.769-.425c2.109-.426-2.389-3.406-3.935-4.26-.858-.473-1.844-2.821-2.552-4.819a3.283,3.283,0,0,0,.445-.646s-1.687-4.685,0-11.781c.717-3.017,1.461-6.474,2.078-9.448,1.174,3.666,2.4,7.443,3.264,10.015a24.754,24.754,0,0,1,1.559,7.43,4.293,4.293,0,0,1-.155,1.37l.03.037c-.018.071-.03.105-.03.105l.053.062c-1.23,1.977.791,4.551.791,4.551l2.529,6.39h1.687l1.617-.994,1.265,1.7a93.153,93.153,0,0,0,9.769-.425c2.109-.426-2.389-3.406-3.935-4.26-1.207-.666-2.672-5.052-3.255-6.943l.3-.084-.044-.129L41,121.5l-1.828-5.394C37.347,115,34.4,95.122,34.4,95.122a15.949,15.949,0,0,1-.557,2.046c.026-.355.176-1.338.557-3.465a20.359,20.359,0,0,0,.327-3.712,13.793,13.793,0,0,0-1.872-7.5c-.06-.964-1.64-4.486-3.438-8.22l2.519-7.831a2.9,2.9,0,0,0,1.622-.13l1.969-5.536s5.2-4.4,6.886-4.4c1.573,0,6.2-1.851,7.733-4.171a3.487,3.487,0,0,0,.281-.511c.318-.724.682-.078,1.041,1.218a10.513,10.513,0,0,1-1.125,1.276,14.089,14.089,0,0,0,1.287-.646c.844,3.507,1.608,10.077,1.608,10.077v5.394l2.385-.334,8.714,18.5a9.544,9.544,0,0,0,5.034,6.253l-.879,1.775,2.248.567.352-.585.074.018.663-1.115c.176.022.351.037.527.05,2.575.167,2.48-1.372,1.406-3.312l.432-.729c2.988.16,1.914,4.574.538,8.138a46.622,46.622,0,0,1-2.025,4.491c2.812,4.97,8.855,4.4,8.855,4.4l.334-.563h.088l3.593-6.048c3.164-3.141,8.556-2.172,12.518-.811a33.765,33.765,0,0,1,4.962,2.16l-.281-.852-.176-.088-.1-.2-2.194-.9L95.23,97.4l-5.8-2.776a7.4,7.4,0,0,1-4.042-.505C79.9,92.068,73.889,85.5,73.56,85.134l-.014-.018-1.563,3.112a53.542,53.542,0,0,0-4-4.466l-6.12-15.975.352-.051-.1-.27.1-.014-3.232-8.659s-1.406-9.369-1.547-13.059-.141-8.8-2.248-11.639l-.06.078-.033-.083,4.173-3.712a2.238,2.238,0,0,0,.251-.019l-.086-.149a8.125,8.125,0,0,0,5.191-2.684,8.279,8.279,0,0,0,2.087-5.5v-.3c1.52.79,3.025.822,3.079-.367A12.217,12.217,0,0,0,62.517,9.807c-3.747-1.56-8.06-1.065-11.883.3a11.734,11.734,0,0,0-2.824,1.361,13,13,0,0,0-2.276,2.176,12.242,12.242,0,0,0-2.942,4.99,5.08,5.08,0,0,0,1.61,5.279c.55.394,1.25.683,1.508,1.314.288.7-.077,1.6.376,2.208.352.478,1.037.513,1.608.676a3.009,3.009,0,0,1,.765.341c-4.127.907-13.757,3.346-16.17,6.777-3.092,4.4-11.952,7.239-11.952,7.239L5.719,48,.8,51.122l.1.222-.1.062s.3.675.715,1.558A7.06,7.06,0,0,0,0,57.445Zm26.093,10.13c-.515-1.017-.965-1.9-1.3-2.554L25.824,63.9s.165.1.452.263Z",
    transform: "translate(0 -8.84)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.7,130.847s1.933,6.807,3.44,7.633,5.914,3.75,3.851,4.167a90.947,90.947,0,0,1-9.56.417L40.2,141.4l-1.582.973h-1.65l-2.485-6.238s-2.614-3.333,0-5.278S43.7,130.847,43.7,130.847Z",
    transform: "translate(-3.056 -11.817)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.844,68.982S34.235,85.1,34.372,87.318c0,0,2.751,3.889,1.513,10.828s0,1.528,0,1.528,2.891,19.457,4.677,20.569l1.787,5.278s-8.665,2.5-10.591,0c0,0,.826-2.222-1.376-8.751s-6.74-20.986-6.74-20.986L12.363,63Z",
    transform: "translate(-1.124 -5.727)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.844,68.831s8.391,16.114,8.528,18.336c0,0,2.751,3.889,1.513,10.827s0,1.528,0,1.528,2.891,19.458,4.677,20.567l1.787,5.279s-8.665,2.5-10.591,0c0,0,.826-2.222-1.376-8.751s-6.74-20.975-6.74-20.975L12.363,62.858Z",
    transform: "translate(-1.124 -5.714)",
    fill: "#3ad29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.972,63.506,25.029,95.643s4.54,14.447,6.74,20.975,1.376,8.751,1.376,8.751a4,4,0,0,0,3.009,1.1c-1.824.08-3.515-.151-4.246-1.1,0,0,.826-2.222-1.376-8.751s-6.74-20.975-6.74-20.975L12.512,62.858Z",
    transform: "translate(-1.137 -5.714)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.883,131.611s1.933,6.807,3.44,7.633,5.914,3.751,3.851,4.168a91.509,91.509,0,0,1-9.561.422l-1.23-1.666-1.582.973H17.15l-2.476-6.252s-2.614-3.334,0-5.279S23.883,131.611,23.883,131.611Z",
    transform: "translate(-1.228 -11.886)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.844,68.982S34.235,85.1,34.372,87.318c0,0,2.751,3.889,1.513,10.828s0,1.528,0,1.528,2.891,19.457,4.677,20.569l1.787,5.278s-8.665,2.5-10.591,0c0,0,.826-2.222-1.376-8.751s-6.74-20.986-6.74-20.986L12.363,63Z",
    transform: "translate(-1.124 -5.727)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,56S-1.415,59.47,3.4,67.8c0,0,6.6,8.612,7.558,12.363l8.528,11.946s-4.677,14.864-3.99,21.123c0,0,.413,8.474-2.751,12.5,0,0,9.078,5.556,11.424,1.112,0,0-1.65-4.585,0-11.538s3.44-16.254,3.44-16.254,6.877-6.528,0-16.531l-9.628-23.2-.963-5.417-4.677-.834Z",
    transform: "translate(-0.137 -4.825)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.191,56.149s-5.914,3.474-1.1,11.807c0,0,6.6,8.612,7.558,12.363l8.528,11.946s-4.677,14.864-3.99,21.123c0,0,.413,8.475-2.751,12.5,0,0,9.078,5.555,11.424,1.111,0,0-1.65-4.585,0-11.537S27.3,99.211,27.3,99.211s6.877-6.528,0-16.53l-9.628-23.2-.96-5.409-4.677-.834Z",
    transform: "translate(-0.109 -4.84)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.191,56S-1.724,59.47,3.09,67.8c0,0,4.851,6.328,6.842,10.5a34.162,34.162,0,0,0,3.046,5.11l6.213,8.7s-4.677,14.864-3.99,21.123c0,0,.413,8.474-2.751,12.5,0,0,9.078,5.555,11.424,1.111,0,0-1.65-4.585,0-11.538s3.44-16.254,3.44-16.254,6.877-6.528,0-16.531l-9.64-23.194-.963-5.417-4.677-.834Z",
    transform: "translate(-0.109 -4.825)",
    fill: "#3ad29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.191,56l7.841-2.916,1.123.2L5.849,55.994S-.066,59.468,4.748,67.8c0,0,4.851,6.328,6.842,10.5a34.173,34.173,0,0,0,3.037,5.11l6.213,8.7s-4.677,14.864-3.99,21.123c0,0,.413,8.474-2.751,12.5a21.909,21.909,0,0,0,7.259,2.781c-3.543.5-8.911-2.781-8.911-2.781,3.164-4.03,2.751-12.5,2.751-12.5-.687-6.252,3.99-21.123,3.99-21.123l-6.213-8.7A34.166,34.166,0,0,1,9.939,78.3C7.945,74.13,3.1,67.8,3.1,67.8-1.72,59.468,4.191,56,4.191,56Z",
    transform: "translate(-0.11 -4.825)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.458,70.373l-3.443,10.7s3.577,12.919.826,13.753-3.99-14.168-3.99-14.168l.687-13.059Z",
    transform: "translate(-2.644 -6.145)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.779,72.79l6.327,16.531S83.827,99.879,77.37,99.462s-7.841-6.807-7.841-6.807L60.172,72.79Z",
    transform: "translate(-5.518 -6.617)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.916,32.84l-7.978,7.084L51.4,31.859s7.428-.694,7.841-3.612S63.916,32.84,63.916,32.84Z",
    transform: "translate(-4.711 -2.507)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,37.868l-.963-2.363-8.667,1.945L48.828,52.315l6.6-.834,2.751-6.39,1.1-5.973Z",
    transform: "translate(-4.475 -3.228)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.006,35.378l.069-4.237s-16.17,2.84-19.188,7.153S21.2,45.379,21.2,45.379L6.89,50.8,2.074,53.861S4.412,59.14,5.1,59.417s6.74-6.669,6.74-6.669l2.751.279L7.435,63.587l18.432,13.2-1.1-8.746,1.787-1.953s5.5,3.333,7.558,2.361l1.933-5.417s5.1-4.306,6.74-4.306c1.54,0,6.067-1.812,7.558-4.083a3.41,3.41,0,0,0,.276-.5c1.1-2.5,2.751,11.669,2.751,11.669v5.279l8.8-1.243-3.164-8.474S57.637,52.2,57.5,48.591s-.137-8.612-2.2-11.39l-2.607,3.465L48.7,50.251l.826-7.918Z",
    transform: "translate(-0.189 -2.831)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.006,35.1,50.561,31s-14.653,2.71-17.674,7.017S21.2,45.1,21.2,45.1L6.89,50.515,2.074,53.572S4.412,58.85,5.1,59.127s6.74-6.669,6.74-6.669l2.751.279L7.435,63.3l18.435,13.2-1.1-8.751,1.787-1.953s5.5,3.333,7.558,2.361l1.933-5.417s5.1-4.306,6.74-4.306c1.54,0,6.067-1.812,7.558-4.083a3.41,3.41,0,0,0,.276-.5c1.1-2.5,2.751,11.669,2.751,11.669v5.279l8.8-1.243-3.164-8.474s-1.376-9.168-1.513-12.78-.137-8.612-2.2-11.39l-2.607,3.47L48.7,49.959l.826-7.918Z",
    transform: "translate(-0.189 -2.818)",
    fill: "#252a62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.766,44.75s-7.558,8.891-7.841,13.059Z",
    transform: "translate(-2.651 -4.068)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.545,50.1s-5.916,6.252-6.6,9.724Z",
    transform: "translate(-3.843 -4.554)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.924,62.161s-.137,3.195,0,4.862Z",
    transform: "translate(-2.624 -5.651)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.368,69.864s-11.554-7.5-12.931-7.084Z",
    transform: "translate(-1.131 -5.706)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.98,28.409c.4-2.792,4.32,3.962,4.654,4.544q-.4.039-.8.041a7.916,7.916,0,0,1-5.77-2.5A3.091,3.091,0,0,0,59.98,28.409Z",
    transform: "translate(-5.32 -2.521)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.466,31.756A8.057,8.057,0,1,0,55.488,23.7,8.018,8.018,0,0,0,63.466,31.756Z",
    transform: "translate(-5.087 -1.422)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.965,22.128a7.937,7.937,0,0,0-1.055,2.744,23.732,23.732,0,0,0,.156,3.227,6.758,6.758,0,0,1-.856,3.3,6.676,6.676,0,0,1-2.352,2.447,1.192,1.192,0,0,0-.427.343.894.894,0,0,0-.116.421c-.04.541.1,1.083.095,1.626a1.438,1.438,0,0,1-.715,1.358,14.53,14.53,0,0,1,2.882,11.381,7.881,7.881,0,0,1-1.42,3.539,8.532,8.532,0,0,1-3.352,2.368A4.8,4.8,0,0,0,56.564,51.9a6.054,6.054,0,0,0-.995-2.813,10.858,10.858,0,0,1-1.109-6.262c.278-2.068,1.213-4.107.837-6.158-.176-.973-.647-1.88-.77-2.861-.088-.7,0-1.42-.142-2.11a3.179,3.179,0,0,0-.771-1.466,3.133,3.133,0,0,0-1.4-.871c-.559-.16-1.23-.193-1.582-.662-.443-.591-.086-1.477-.367-2.162-.253-.616-.937-.9-1.476-1.285a4.987,4.987,0,0,1-1.582-5.165A11.9,11.9,0,0,1,50.087,15.2a12.575,12.575,0,0,1,2.227-2.13,11.484,11.484,0,0,1,2.8-1.331c3.742-1.329,7.964-1.816,11.63-.289a11.958,11.958,0,0,1,7.122,11.3c-.121,2.473-6.624-.431-6.108-4.413.214-1.653-1.833-1.285-3.106-.028A16.5,16.5,0,0,0,61.965,22.128Z",
    transform: "translate(-4.317 -0.955)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.773,21.933a7.935,7.935,0,0,0-1.055,2.744,23.729,23.729,0,0,0,.156,3.227,6.758,6.758,0,0,1-.856,3.3,6.677,6.677,0,0,1-2.352,2.447,1.192,1.192,0,0,0-.427.343.9.9,0,0,0-.116.421c-.04.541.1,1.083.095,1.626A1.439,1.439,0,0,1,56.5,37.4a14.53,14.53,0,0,1,2.882,11.381,7.882,7.882,0,0,1-1.42,3.539,8.532,8.532,0,0,1-3.352,2.368,4.8,4.8,0,0,0,1.758-2.979,6.054,6.054,0,0,0-.995-2.813,10.858,10.858,0,0,1-1.109-6.262c.278-2.068,1.213-4.107.837-6.158-.176-.973-.647-1.88-.77-2.861-.088-.7,0-1.42-.142-2.111a3.179,3.179,0,0,0-.771-1.466,3.133,3.133,0,0,0-1.4-.871c-.559-.16-1.23-.193-1.582-.662-.443-.591-.086-1.477-.367-2.162-.253-.616-.937-.9-1.476-1.285a4.987,4.987,0,0,1-1.582-5.165A11.9,11.9,0,0,1,49.9,15.006a12.574,12.574,0,0,1,2.227-2.13,11.483,11.483,0,0,1,2.8-1.331c3.742-1.33,7.964-1.816,11.63-.289a11.958,11.958,0,0,1,7.122,11.3c-.121,2.473-6.624-.431-6.108-4.413.214-1.653-1.833-1.285-3.106-.028A16.5,16.5,0,0,0,61.773,21.933Z",
    transform: "translate(-4.3 -0.937)",
    fill: "#6f684a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.886,40.527h1.8a.477.477,0,0,0,.475-.479v-.014a.477.477,0,0,0-.475-.479h-1.8a.477.477,0,0,0-.475.479v.014A.477.477,0,0,0,55.886,40.527Z",
    transform: "translate(-5.076 -3.596)",
    fill: "#252a62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.383,101.734l2.2.555,2.969-5,.332-.559c3.211.087,1.823,4.988.36,8.591-.856,2.109-1.737,3.774-1.737,3.774,2.557,4.521,7.849,4.358,8.581,4.312h.086l3.515-5.918.2-.334c3.116-3.4,8.533-2.149,12.4-.587a31.716,31.716,0,0,1,4.508,2.247l-.276-.835-.175-.087-2.243-1.065-4.965-2.375-5.678-2.717a7.22,7.22,0,0,1-3.955-.5c-5.371-2.009-11.249-8.444-11.576-8.8l-.014-.016Z",
    transform: "translate(-6.92 -8.403)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.383,101.734l2.2.555,2.969-5,.332-.559c3.211.087,1.823,4.988.36,8.591-.856,2.109-1.737,3.774-1.737,3.774,2.557,4.521,7.849,4.358,8.581,4.312h.086l3.515-5.918.2-.334c3.116-3.4,8.533-2.149,12.4-.587a31.716,31.716,0,0,1,4.508,2.247l-.276-.835-.175-.087-2.243-1.065-4.965-2.375-5.678-2.717a7.22,7.22,0,0,1-3.955-.5c-5.371-2.009-11.249-8.444-11.576-8.8l-.014-.016Z",
    transform: "translate(-6.92 -8.403)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.93,102.287l2.2.555.341-.573,2.96-4.983h.079c2.932.156,1.874,4.476.527,7.964a45.829,45.829,0,0,1-1.981,4.39c2.751,4.862,8.665,4.305,8.665,4.305l.327-.55,3.387-5.7c.07-.076.142-.151.214-.222,3.1-3.075,8.375-2.13,12.25-.794a32.924,32.924,0,0,1,4.864,2.13l-.55-1.111-2.148-.888-2.772-1.137-8.285-3.4a7.026,7.026,0,0,1-4.173-.663C85.644,99.35,80.2,92.8,79.893,92.427l-.014-.016Z",
    transform: "translate(-6.879 -8.401)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.166,122.361a.261.261,0,0,0,.186-.078.268.268,0,0,0,0-.376.261.261,0,0,0-.372,0,.268.268,0,0,0,0,.376A.262.262,0,0,0,100.166,122.361Z",
    transform: "translate(-9.151 -11.075)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.469,110.552c2.751,4.862,8.665,4.305,8.665,4.305l.327-.55h.086l3.515-5.918c3.1-3.074,8.375-2.13,12.251-.793l.351-.128a1.764,1.764,0,0,0,.257-.106,6.89,6.89,0,0,0-1.206-.769c-.588-.342-1.351-.495-2.193-.96l-5.684-2.714a7.22,7.22,0,0,1-3.955-.5c-.2.119-.415-.028-.631.112a29.033,29.033,0,0,0-4.492,3.578c-1.262,1.275-3.552.732-5.141.117l-.167-.067A45.755,45.755,0,0,1,79.469,110.552Z",
    transform: "translate(-7.291 -9.311)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.353 100.614)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.824,117.515a9.825,9.825,0,0,0,.239,1.762c.09.341.215.673.28,1.019.2,1.1-.2,2.363.465,3.254a.5.5,0,0,1-.36.08.506.506,0,0,1-.318-.188,1.227,1.227,0,0,1-.232-.71,8.663,8.663,0,0,0-.224-2.8,9.038,9.038,0,0,1-.663-1.332,11.311,11.311,0,0,1,.045-1.8,8.664,8.664,0,0,0-.366-1.42c-.372-1.532.275-3.128.2-4.7C112.988,112.467,112.669,115.415,112.824,117.515Z",
    transform: "translate(-111.574 -110.675)",
    fill: "#4d8af0",
    opacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.1b580649155df766cd0ab527036c38c6.svg";
export { ForwardRef as ReactComponent };